import { render, staticRenderFns } from "./todosStatus.vue?vue&type=template&id=24b0c678&scoped=true&"
import script from "./todosStatus.vue?vue&type=script&lang=js&"
export * from "./todosStatus.vue?vue&type=script&lang=js&"
import style0 from "./todosStatus.vue?vue&type=style&index=0&id=24b0c678&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b0c678",
  null
  
)

export default component.exports